module.exports = __webpack_public_path__ + "img/icona-badges.cc938007.png";